import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPieLineGraph = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "pie-line-graph" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.246,19.5l3.97-3.97a.75.75,0,0,1,1.061,0l1.939,1.939a.75.75,0,0,0,1.061,0L20.246,13.5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .746,
			y: .75,
			width: 22.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 8.246,
			cy: 8.25,
			r: 4.5
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "8.246 3.75 8.246 8.25 11.428 11.432"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.496,
			y1: 5.25,
			x2: 19.496,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.496,
			y1: 8.25,
			x2: 19.496,
			y2: 8.25
		})
	]
});
export default SvgPieLineGraph;
